<template>
    <div>
        <div v-if="loading" class="mt-10 pt-10">
            <div class="d-flex align-center justify-center">
                <v-progress-circular :width="5" :size="80" color="primary" indeterminate></v-progress-circular>
            </div>
        </div>
        <div v-else>
            <div>
                <dispensing-actions :disabled="disabled"></dispensing-actions>
            </div>
            <div class="pt-5">
                <b-alert v-if="readOnlyRules" :message="t('patients::alert.dispensing_can_be_permitted')"></b-alert>
            </div>
            <v-row>
                <v-col cols="12" xl="8">
                    <dispensing-time-line :disabled="disabled"></dispensing-time-line>
                </v-col>
                <v-col v-if="dispensingStarting" cols="12" xl="4">
                    <b-alert
                        v-if="hasTreatmentBreak"
                        :message="t('patients::dispensing.info.title.schedule_restart')"
                        has-content
                    >
                        <div>
                            <span v-if="treatmentBreakPeriod">
                                {{ dispensingScheduleOptionsSelected.text }}
                                <p class="mt-2" style="word-break: break-word">
                                    {{
                                        t(
                                            'patients::dispensing.info.schedule_restart.copy.' +
                                                dispensingScheduleOptionsSelected.text.replaceAll(' ', '_')
                                        )
                                    }}
                                </p>
                            </span>
                            <span v-else>
                                {{ t('patients::dispensing.form.label.schedule_restart_period') }}
                                <p>{{ t('patients::dispensing.info.schedule_restart.copy.na') }}</p>
                            </span>
                        </div>
                    </b-alert>
                    <b-alert
                        v-if="canDispensedDays"
                        :message="t('patients::dispensing.info.title.pills_dispensing')"
                        has-content
                    >
                        <div>
                            <p>{{ t('patients::dispensing.info.copy_top.pills_dispensing') }}</p>
                            <ul>
                                <li>
                                    <strong>{{ t('patients::dispensing.info.list_item_1.pills_dispensing') }}</strong>
                                </li>
                                <li>
                                    <strong>{{ t('patients::dispensing.info.list_item_2.pills_dispensing') }}</strong>
                                </li>
                                <li>
                                    <strong>{{ t('patients::dispensing.info.list_item_3.pills_dispensing') }}</strong>
                                </li>
                            </ul>
                            <p>{{ t('patients::dispensing.info.copy_bottom.pills_dispensing') }}</p>
                        </div>
                    </b-alert>
                    <b-alert
                        v-if="hasSchedule || canDispensedDays"
                        :message="t('patients::dispensing.info.title.blood_validity')"
                        has-content
                    >
                        <div>
                            <p>{{ t('patients::dispensing.info.copy_top.blood_validity') }}</p>
                            <ul>
                                <li>
                                    <strong>{{ t('patients::dispensing.info.list_item_1.blood_validity') }}</strong>
                                </li>
                                <li>
                                    <strong>{{ t('patients::dispensing.info.list_item_2.blood_validity') }}</strong>
                                </li>
                                <li>
                                    <strong>{{ t('patients::dispensing.info.list_item_3.blood_validity') }}</strong>
                                </li>
                            </ul>
                        </div>
                    </b-alert>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {};
    },
    computed: {
        loading() {
            return this.$store.state.patients.dispensingLoading;
        },
        readOnlyRules() {
            return !this.$store.state.patients.patient.is_registered;
        },
        patientId() {
            return this.$store.state.patients.patient.id;
        },
        dispensing() {
            return this.$store.state.patients.patient.dispensing;
        },
        dispensingStarting() {
            return !!this.$store.state.patients.patient.dispensing.permitted;
        },
        hasSchedule() {
            return this.dispensing.has_schedule;
        },
        hasTreatmentBreak() {
            return this.dispensing.has_treatment_break;
        },
        canDispensedDays() {
            return (
                !!this.dispensing.permitted &&
                this.dispensing.has_schedule &&
                !this.dispensing.has_treatment_break &&
                this.can('api.v1.patients.dispensing-days.dispensed')
            );
        },
        treatmentBreakPeriod() {
            return this.$store.state.patients.dispensingForm.schedule_restart_period;
        },
        dispensingScheduleOptionsSelected() {
            return this.$store.state.patients.dispensingScheduleOptions.find(
                (x) => x.value === this.treatmentBreakPeriod
            );
        },
    },
    created() {
        this.$store.dispatch('patients/loadDispensingScheduleOptions');
    },
    mounted() {
        this.loadTimeLine();
    },
    methods: {
        loadTimeLine() {
            this.$store.dispatch('patients/loadDispensingSummary');
        },
    },
};
</script>

<style></style>
